import { Env, sharedConfig } from "@zickko/shared";

type FirebaseConfig = {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
  inboundEmailBucket: string;
  outboundEmailBucket: string;
};

type ClientConfig = FirebaseConfig & {
  env: Env;
  gcsBaseUrl: string;
  isCypress: boolean;
  imageServer: string;
  algolia: {
    appId: string;
    searchOnlyApiKey: string;
    talentProfileIndex: string;
  };
  inboundEmailBucket: string;
  outboundEmailBucket: string;
};

const devConfig: ClientConfig = {
  env: Env.dev,
  apiKey: "AIzaSyAGhKS9OnLFWrUtKsi7saW0CtxNJ_737E8",
  authDomain: "zickko-dev.firebaseapp.com",
  projectId: "zickko-dev",
  storageBucket: sharedConfig.devConfig.defaultBucket,
  // storageBucket: "zickko-dev.firebasestorage.app",
  messagingSenderId: "958163738560",
  appId: "1:958163738560:web:2c50bb8fe9ed824e59b225",
  measurementId: "G-BFSD3KWEPX",
  gcsBaseUrl: "https://storage.googleapis.com",
  isCypress: false,
  imageServer: "./images", // served from relative URLs
  algolia: {
    appId: "",
    searchOnlyApiKey: "",
    talentProfileIndex: "talent_profile_index",
  },
  inboundEmailBucket: sharedConfig.devConfig.inboundEmailBucket,
  outboundEmailBucket: sharedConfig.devConfig.outboundEmailBucket,
};

const stagingConfig: ClientConfig = {
  env: Env.staging,
  apiKey: "AIzaSyA_KadVcDd1Be6qwNUi4nNjdjMe8SKlaZA",
  authDomain: "zickko-staging.firebaseapp.com",
  projectId: "zickko-staging",
  storageBucket: sharedConfig.stagingConfig.defaultBucket,
  // storageBucket: "zickko-staging.firebasestorage.app",
  messagingSenderId: "325231543259",
  appId: "1:325231543259:web:83c3a35f75b37ad7be1dfe",
  measurementId: "G-RPHD3GS33L",
  gcsBaseUrl: "https://storage.googleapis.com",
  isCypress: false,
  imageServer: "./images", // served from relative URLs
  algolia: {
    appId: "",
    searchOnlyApiKey: "",
    talentProfileIndex: "talent_profile_index",
  },
  inboundEmailBucket: sharedConfig.stagingConfig.inboundEmailBucket,
  outboundEmailBucket: sharedConfig.stagingConfig.outboundEmailBucket,
};

// using staging config for local now
const localConfig: ClientConfig = {
  ...stagingConfig,
  env: Env.local,
  storageBucket: stagingConfig.storageBucket,
  inboundEmailBucket: stagingConfig.inboundEmailBucket,
  outboundEmailBucket: stagingConfig.outboundEmailBucket,
  gcsBaseUrl: "http://localhost:9199",
  imageServer: "http://localhost:5002/images",
  algolia: {
    appId: "NI9RBWZF0I",
    searchOnlyApiKey: "18e823ac7924bce7dfab943052a3df05",
    talentProfileIndex: "talent_profile_index",
  },
};

// using staging config for production now
// const productionConfig: ClientConfig = {
//   ...stagingConfig,
//   env: Env.local,
// };

const hostname = window.location.hostname;
const PRODUCTION_HOSTNAMES = ["staging.zickko.com"];

const isStaging = PRODUCTION_HOSTNAMES.includes(hostname) ? true : false;
const isLocal =
  hostname.includes("localhost") || hostname.includes("127.0.0.1") || hostname.endsWith(".local") ? true : false;
const isDev = hostname.includes("dev-admin-portal") ? true : false;
// const isStaging = hostname.includes("staging-admin-portal") ? true : false;

export const clientConfig = (function () {
  if (isDev) {
    console.log(`*** Dev Mode ***`);
    return devConfig;
  }
  if (isLocal) {
    console.log(`*** LOCAL Mode ***`);
    return localConfig;
  }
  // if (isProduction) {
  //   console.log(`*** Production Mode ***`);
  //   return productionConfig;
  // }
  if (isStaging) {
    console.log(`*** STAGING Mode ***`);
    return stagingConfig;
  }
  console.log(`*** Default to STAGING Mode hcdftuyhkigiufytrsdiky ***`);
  return stagingConfig;
})();
